import { render, staticRenderFns } from "./RegistrationStatement.vue?vue&type=template&id=364b9086&scoped=true&"
import script from "./RegistrationStatement.vue?vue&type=script&lang=js&"
export * from "./RegistrationStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b9086",
  null
  
)

export default component.exports